
import { Layout, Menu, Select } from 'antd';
import { Link, Outlet, useLocation, useParams } from 'react-router-dom';
import { LanguagePicker } from '@/modules/i18n/LanguagePicker';
import { useIntl } from 'react-intl';
import { useEffect } from 'react';
import { useAppDispatch } from '@/AppRedux/store/hooks';
import { requestTheme, setThemeSuccess } from '@/AppRedux/actions/theme';
import { themeOptions } from '@/AppRedux/reducers/theme';
import HotelProfileStateHook from '@/hooks/useHotelProfileState';
import useIsMobile from '@/hooks/useIsMobile';
import { isNull } from 'lodash';
import useIsExtraLarge from '@/hooks/useIsExtraLarge';

const { Header, Content, Footer } = Layout;

/* Hide Feature check booking status */
const CheckBookingStatusFeatureOn = false

export default function PublicLayout() {
  const { pathname } = useLocation();
  const { propcode } = useParams<{ propcode?: string }>();
  const isMobile = useIsMobile(768);
  const isExtraLarge = useIsExtraLarge(1599);

  const intl = useIntl();
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Load theme settings dynamically for current property (if any)
    dispatch(requestTheme(propcode));
  }, [propcode]);

  const bookingPath = propcode ? `/booking/${propcode}` : '/booking';

  const { dataSource } = HotelProfileStateHook()

  const getSelectedKey = () => {
    if (pathname.endsWith('/status')) {
      return 'status';
    }
    if (pathname.startsWith('/booking')) {
      return 'booking';
    }
    return 'home';
  };

  const menuItems = (): any[] => {
    const baseItems = [
      /*
      {
        key: 'home',
        label: (
          <Link to="/" onClick={() => dispatch(resetHotelProfile())}>
            {intl.formatMessage({ id: 'nav.home', defaultMessage: 'Home' })}
          </Link>
        ),
      },*/
      {
        key: 'booking',
        label: (
          <Link to={bookingPath}>
            {intl.formatMessage({ id: 'nav.home', defaultMessage: 'Home' })}
          </Link>
        ),
      },
    ];

    if (CheckBookingStatusFeatureOn && propcode && !isNull(dataSource)) {
      baseItems.push({
        key: 'status',
        label: (
          <Link to={`${bookingPath}/status`}>
            {intl.formatMessage({ id: 'nav.status', defaultMessage: 'Check Booking' })}
          </Link>
        ),
      });
    }
    return baseItems;
  }
  const themeDemoSelection =  import.meta.env.VITE_THEME_DEMO_SELECTION === 'true' ? true : false;

  return (
    <Layout style={{ minHeight: '100vh' , maxWidth: isExtraLarge ? 1700 :'90vw' , margin: '0 auto' }}>
      <Header style={{ display: 'flex', alignItems: 'center', padding:isMobile ? 0 :"0 25px", position: 'sticky',top: 0, zIndex: 99, }}>
        <Menu mode="horizontal" selectedKeys={[getSelectedKey()]} items={menuItems()} style={{ flex: 1, background: 'transparent', borderBottom: 'none' }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>

          <LanguagePicker propcode={propcode} />

          <Select
            size="small"
            variant="borderless"
            defaultValue={themeOptions[0].value}
            style={{ minWidth: 160 , display: themeDemoSelection ? 'flex' : 'none' }}
            options={themeOptions.map(o => ({ label: o.label, value: o.value }))}
            onChange={(val) => {
              const found = themeOptions.find(o => o.value === val);
              if (found) {
                dispatch(setThemeSuccess(found.theme));
              }
            }}
          />
        </div>
      </Header>

      <Content style={{ padding: isMobile ? "24px 0 " : 24 }}>
        <Outlet />
      </Content>

      <Footer style={{ textAlign: 'center' }}>
        © {new Date().getFullYear()} Booking Channel
      </Footer>
    </Layout>
  );
}
